import { z } from 'zod';

/**
 * The `inbox` channel's events. They are hints carrying ids and, at most, a
 * message index; never a body, preview, title or name.
 *
 * `parse` throws on anything that is not a known v1 event, and the realtime
 * client drops a thrown event while keeping the socket open, so an event type
 * added server-side later is ignored until the app learns it.
 */

const conversationData = z.object({ conversationId: z.string().min(1) });

const indexedData = conversationData.extend({ index: z.number().int().min(0) });

const inboxEventSchema = z.discriminatedUnion('type', [
  z.object({ v: z.literal(1), type: z.literal('message.created'), data: indexedData }),
  z.object({ v: z.literal(1), type: z.literal('message.updated'), data: indexedData }),
  z.object({ v: z.literal(1), type: z.literal('conversation.read'), data: indexedData }),
  z.object({ v: z.literal(1), type: z.literal('conversation.created'), data: conversationData }),
]);

export type InboxRealtimeEvent = z.infer<typeof inboxEventSchema>;

export function parseInboxRealtimeEvent(raw: unknown): InboxRealtimeEvent {
  return inboxEventSchema.parse(raw);
}

export function inboxChannelFor(userId: string): string {
  return `/inbox/${userId}/*`;
}
